import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Intervention from "./components/Intervention";
import Signes from "./components/Signes";
import ReparerPlutot from "./components/ReparerPlutot";
import PiecesAssociees from "./components/PiecesAssociees";
import Maillage from "./components/Maillage";
import Formulaire from "./components/Formulaire";
import Avis from "@/components/feature/Avis";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";
import Footer from "./components/Footer";
import FloatingButton from "./components/FloatingButton";

export default function CordonVoletRoulantPage() {
  return (
    <div className="font-sans">
      <SEOHead
        title="Cordon Volet Roulant Strasbourg | Remplacement Toutes Marques"
        description="Remplacement de cordon de volet roulant à Strasbourg et dans le Bas-Rhin. Toutes dimensions, toutes marques, devis gratuit. 03 74 47 32 40."
        path="/cordon-volet-roulant"
        type="service"
        serviceType="Remplacement de cordon de volet roulant"
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Cordon volet roulant" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Cordon volet roulant" }]} />
      <main>
        <Hero />
        <DiagnosticVideo />
        <Intervention />
        <Signes />
        <ReparerPlutot />
        <PiecesAssociees />
        <Maillage />
        <Formulaire />
        <Avis />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}